import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { arabicTranslations } from "./translations";

const STORAGE_KEY = "hpa-language";
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem(STORAGE_KEY) === "ar" ? "ar" : "en");

  useEffect(() => {
    const isArabic = language === "ar";
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
    document.documentElement.dir = isArabic ? "rtl" : "ltr";
    document.body.classList.toggle("hpa-rtl", isArabic);
  }, [language]);

  const t = useCallback((key, replacements = {}) => {
    const translated = language === "ar" ? (arabicTranslations[key] || key) : key;
    return Object.entries(replacements).reduce(
      (text, [name, value]) => text.replaceAll(`{${name}}`, value ?? ""),
      translated,
    );
  }, [language]);

  const value = useMemo(() => ({
    language,
    isArabic: language === "ar",
    setLanguage,
    toggleLanguage: () => setLanguage((current) => current === "en" ? "ar" : "en"),
    t,
  }), [language, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside LanguageProvider");
  return context;
};
